import React from "react";
import { Box } from "@mui/material";
import Bubles from "./../assets/images/bubles/Bubles.png";

const BubblesBackground = ({  top, right, left,bottom}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: top , 
        right: right  , 
        left: left  , 
        width: { xs: "100px", sm: "150px", md: "200px", lg: "250px" },
        height: "auto",
        bottom:bottom||"auto"
     
      }}
    >
      <img src={Bubles} alt="Background Bubbles" style={{ width: "100%", height: "auto" , zIndex: 1}} />
    </Box>
  );
};

export default BubblesBackground;